module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-height-100",
    attrs: {
      "id": "app"
    }
  }, [_c('Sidebar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('GoogleAnalytics')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 452
// module chunks = 1